import { ECOSYSTEM_CTA, ECOSYSTEM_SEO } from '@/data/ecosystem';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { EcosystemExplorer } from '@/components/site/ecosystem/EcosystemExplorer';
import { PurchasingNote } from '@/components/site/ecosystem/PurchasingNote';
import { CtaBand } from '@/components/site/CtaBand';

export default function EcosystemPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: ECOSYSTEM_SEO.title,
    description: ECOSYSTEM_SEO.description,
    canonical: `${origin}/ecosystem`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: ECOSYSTEM_SEO.title,
      description: ECOSYSTEM_SEO.description,
      url: `${origin}/ecosystem`,
    },
  });

  return (
    <>
      <EcosystemExplorer />
      <PurchasingNote />
      <CtaBand
        index={ECOSYSTEM_CTA.index}
        eyebrow={ECOSYSTEM_CTA.eyebrow}
        heading={ECOSYSTEM_CTA.heading}
        copy={ECOSYSTEM_CTA.copy}
        primaryLabel={ECOSYSTEM_CTA.primaryLabel}
        primaryHref={ECOSYSTEM_CTA.primaryHref}
        secondaryLabel={ECOSYSTEM_CTA.secondaryLabel}
        secondaryHref={ECOSYSTEM_CTA.secondaryHref}
      />
    </>
  );
}
